//noinspection JSFileReferences
import index from './courses/index.js';

index.init();